import React from 'react';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
const MetricsBoard = (props: any) => {
  let { data } = props;
  return (
    <div className="dbi-metrics-board">
      <div className="dbi-metrics-board-title">{data.title}</div>
      <div className="dbi-metrics-board-content">
        <div className="dbi-metrics-board-first">
          <div className="dbi-col-title">{data.metricsBoard.title}</div>
          <div className="dbi-metrics-board-num">{data.metricsBoard.num}</div>
          <div className="dbi-metrics-board-text">
            {data.metricsBoard.textList.map((item: any, i: any) => (
              <div className="dbi-metrics-board-text-flex" key={i}>
                <div className="dbi-label-text">{item.value}</div>
                {/* 样式 dbi-text-green dbi-text-red */}
                <div
                  className={
                    item.text.indexOf('-') ? 'dbi-text-green' : 'dbi-text-red'
                  }
                >
                  {item.text}
                </div>
                <SvgIcon
                  type={item.text.indexOf('-') ? 'green-up-new' : 'red-down-new'}
                  className="dbi-text-svg"
                />
              </div>
            ))}
          </div>
        </div>
        {data.chartList.map((item: any, t: any) => (
          <div className="dbi-metrics-board-col" key={t}>
            <div className="dbi-col-title">{item.title}</div>
            {item?.child}
            {item?.chartData}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetricsBoard;
